import React from 'react';
import { useIntl } from 'umi';
import classnames from 'classnames';
import { Radio } from 'tea-component';

export interface IOverallAllSectionProps {
  /** 是否为 Overall All 选中态（isAllState=true 且 values 为空） */
  isSelected: boolean;
  /** 选中 Overall All：isAllState=true 且 values=[] */
  onSelect?: () => void;
  /** 通过 CSS 隐藏（搜索中 / 加载中等），避免条件渲染反复挂载 DOM */
  isHidden?: boolean;
}

/**
 * Overall 聚合数据分区：展示 Overall 标题与 All 单选项。
 */
const OverallAllSection: React.FC<IOverallAllSectionProps> = ({
  isSelected,
  onSelect,
  isHidden = false,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div
      className={classnames('dbl-string-selector-overall', {
        'dbl-string-selector-overall--hidden': isHidden,
      })}
    >
      <Radio.Group
        className="dbl-string-selector-overall__radio"
        value={isSelected ? 'all' : ''}
        onChange={(value: string) => {
          if (value === 'all') {
            onSelect?.();
          }
        }}
      >
        <Radio name="all">{formatMessage({ id: 'dbl_common_all' })}</Radio>
      </Radio.Group>
    </div>
  );
};

export default OverallAllSection;
